


































import { ScreenSize } from '@/main/components/constants';
import { PageMode } from '@/main/utils/pageMode';
import { openEdit } from '@/main/router/routerPath';
import { EventBus } from '@/main/eventBus';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';
import DropButtons from '@/modules/servis/zakazka/components/DropButtons.vue';
import { PROrdersParts } from '@/modules/sklad/PROrders/parts/index';

import { MIO_PZN } from './constants';
import { NAME as ndObjednavkaName } from '../../../sklad/ndObjednavka/constants';
import { NAME as rezervaceName } from '../../rezervaceND/constants';

type dialog = { visible: boolean, title: string | null, table: Record<string, any> | null };

export default EditStoreMixin.extend({
	components: {
		DropButtons,
	},
	props: {
		zakazkaId: { type: Number },
		vyrobekndOzn: { type: String },
		ndNr: { type: String },
		skladOzn: { type: Number },
		buttonEnabled: { type: Object },
		dependentTables: { type: Object },
	},
	data() {
		return {
			dialog: { visible: false, title: null, table: null } as dialog,
			showScrollArrow: false,
			enableClass: false,
			lstOrdersButtons: [
				{ labelKey: '' as string | null, click: '' as string | null, disable: '' as string | boolean | null, exist: true as boolean | null },
			],
			screenSize: ScreenSize.MEDIUM,
			windowWidth: window.innerWidth,
		};
	},
	updated() {
		EventBus.$emit('Mode', this.pageMode);
	},
	computed:
	{
		prOrderButtons(): object {
			this.lstOrdersButtons =			[
				{ labelKey: 'cmdPohyb', click: 'onPohybyClick', disable: !this.buttonEnabled.cmdPohyb, exist: true },
				{ labelKey: 'Mio', click: 'onRyOclick', disable: !this.buttonEnabled.cmdMio, exist: true },
				{ labelKey: 'So', click: 'onSkOClick', disable: !this.buttonEnabled.cmdSo, exist: true },
				{ labelKey: 'MioSklad', click: 'onRyONaSkladClick', disable: !this.buttonEnabled.cmdMioSklad, exist: true },
				{ labelKey: 'Rezervace', click: 'onRezervaceClick', disable: !this.buttonEnabled.cmdRezervace, exist: true },
				{ labelKey: 'NDNahradaPred', click: 'onNahradaNdPredchudciClick', disable: !this.buttonEnabled.cmdNDNahradaPred, exist: true },
				{ labelKey: 'NDNahradaPo', click: 'onNahradaNdNasledniciClick', disable: !this.buttonEnabled.cmdNDNahradaPo, exist: true },
				{ labelKey: 'cmdShoda', click: 'onShodniNdClick', disable: !this.buttonEnabled.cmdShoda, exist: true },
			];
			return this.lstOrdersButtons
				.filter((item) => item.labelKey !== undefined && item.labelKey != null && item.exist)
				.map((item) => ({
					labelKey: item.labelKey,
					click: () => { this.call(item.click); },
					exist: item.exist,
					disable: item.disable,
				}));
		},

		isTabletEnabled(): boolean {
			return this.windowWidth > this.screenSize;
		},

	},
	/** Emits the 'Mode' event. */
	mounted() {
		EventBus.$emit('Mode', this.pageMode);

		this.enableClass = window.innerWidth < 1500;
		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth;
		});
	},
	methods: {
		call(method:any) {
			(this as { [key:string]:any })[method]();
		},
		dropButtonLabel():string {
			return window.innerWidth > 374 ? 'Parts' : '..';
		},
		hideButton():boolean {
			return window.innerWidth < 400;
		},
		onPohybyClick() {
			this.dialog = { visible: true, title: this.LocalizeFormular('repNdpohyb'), table: this.dependentTables.NdpohybZakazka };
		},
		onNahradaNdNasledniciClick() {
			this.dialog = { visible: true, title: this.LocalizePopisostatni('NDNahradaPo'), table: this.dependentTables.NahradyNasledovnici };
		},
		onNahradaNdPredchudciClick() {
			this.dialog = { visible: true, title: this.LocalizePopisostatni('NDNahradaPred'), table: this.dependentTables.NahradyPredchudce };
		},
		onShodniNdClick() {
			this.dialog = { visible: true, title: this.LocalizePopisostatni('cmdShoda'), table: this.dependentTables.ShodaNd };
		},
		onRyOclick() {
			this.openNdObjednavkaEdit(MIO_PZN.RYO, this.zakazkaId);
		},
		onSkOClick() {
			this.openNdObjednavkaEdit(MIO_PZN.SKO);
		},
		onRyONaSkladClick() {
			this.openNdObjednavkaEdit(MIO_PZN.RYO);
		},
		openNdObjednavkaEdit(MioPzn: number, ZakazkaId?: number) {
			if (this.loggedUser.DmsSys.PROrdersPrp) {
				openEdit(PROrdersParts.name, PageMode.CREATE, {
					filter:
					{
						ZakazkaId,
						VyrobekndOzn: this.vyrobekndOzn,
						NdNr: this.ndNr,
						SkladOzn: this.skladOzn,
						MioPzn,
					},
				});
			} else {
				openEdit(
					ndObjednavkaName,
					PageMode.CREATE,
					{
						filter: { ZakazkaId, VyrobekndOzn: this.vyrobekndOzn, NdNr: this.ndNr, SkladOzn: this.skladOzn, MioPzn },
					},
				);
			}
		},
		onRezervaceClick() {
			openEdit(
				rezervaceName,
				PageMode.CREATE,
				{
					filter: { ZakazkaId: this.zakazkaId, VyrobekndOzn: this.vyrobekndOzn, NdNr: this.ndNr, SkladOzn: this.skladOzn },
				},
			);
		},
		scrollNavbar(direction: string) {
			const content = document.querySelector('.el-menu--horizontal');
			if (content !== null) {
				if (direction === 'right') content.scrollLeft += 250;
				else content.scrollLeft -= 250;
			}
		},
		getWidth() {
			this.showScrollArrow = window.innerWidth < this.screenSize;
		},
	},
	created() {
		window.addEventListener('resize', this.getWidth);
	},
	destroyed() {
		window.removeEventListener('resize', this.getWidth);
	},
});
